import React, { createContext, useContext, useMemo } from 'react';
import { distance } from '@turf/turf';
import { Lat, Lng } from '@web-shared/types/Map.types';

export const DeliveryTokenContext = createContext<string | null>(null);

export const useBolAuthToken = () => useContext(DeliveryTokenContext);

interface Props {
  children: React.ReactNode;
  token: string;
  userPosition: GeolocationPosition;
  bolPosition: [Lat, Lng] | undefined;
}

export const DeliveryTokenProvider = ({ children, token, userPosition, bolPosition }: Props) => {

  const value = useMemo(() => {
    if (!bolPosition) return null;

    const dist = distance(
      [userPosition.coords.longitude, userPosition.coords.latitude],
      [bolPosition[1], bolPosition[0]],
      { units: 'miles' }
    );

    if (dist < 1) return token;
    return null;

  }, [token, userPosition]);

  return (
    <DeliveryTokenContext.Provider value={value} >
      {children}
    </DeliveryTokenContext.Provider>
  );
};
